import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../features/auth/hooks/useAuth';
import { useUser } from '@/features/user/hooks/useUser';
import { PageLoader } from '../../layouts/components/PageLoader/PageLoader';
import { routes } from '../routes';
import { useEffect } from 'react';

export const AuthGuard = () => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { user, isLoading: isUserLoading, getUser } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && !isUserLoading && !user) {
      getUser();
    }
  }, [isAuthenticated, user, isUserLoading]);

  useEffect(() => {
    if (!isAuthenticated && !authLoading) {
      navigate(routes.public.signup);
    }
  }, [isAuthenticated, authLoading]);

  if (authLoading || isUserLoading) {
    return <PageLoader />;
  }

  if (!isAuthenticated) {
    return <Navigate to={routes.public.signup} replace />;
  }

  return <Outlet />;
};
